import React from 'react';
import { FieldArray } from "redux-form";
import { icons } from "icons"; // Ajusta según tu ruta de iconos
import { preciosSucursal } from "../camposProducto"; // Ajusta la ruta

const PrecioSucursalSection = ({ 
    readOnlyMode = false,
    isModal = false, 
    hasPreciosSucursal, 
    onNext, 
    onPrevious, 
    canGoNext, 
    canGoPrevious, 
    sucursales, 
    sucursal, 
    changeSucursal, 
    sucursal_activo, 
    nombres_precios, 
    changeSucursalActivo, 
    conf_porcentaje_precio, 
    cambioPorcentajePrecio, 
    precios_sucursalValue,
    nombreFormulario = "ProductoCrear"
}) => {
    
    const [mostrarFormulario, setMostrarFormulario] = React.useState(() => {
        return hasPreciosSucursal || (precios_sucursalValue && precios_sucursalValue.length > 0);
    });

    return (
        <div className={isModal ? "" : "section-panel"}>
            {!isModal && (
                <div className="section-header">
                    <h4>Precio Sucursal (opcional)</h4>
                    {!readOnlyMode && (
                    <div className="section-actions">
                        <button type="button" className="btn btn-secondary" onClick={onPrevious} disabled={!canGoPrevious}>Regresar</button>
                        <button type="button" className="btn btn-primary" onClick={onNext} disabled={!canGoNext}>Siguiente</button>
                    </div>
                    )}
                </div>
            )}
            
            <div className="row row-fields">
                <div className={isModal ? "col-12" : "col-lg-12 col-md-12 col-sm-12"}>
                    {!mostrarFormulario && !hasPreciosSucursal ? (
                        <div className="d-flex flex-column align-items-center justify-content-center py-4">
                            <img src={icons.sin_datos} alt="Sin datos" style={{ width: "120px", marginBottom: '1rem' }} />
                            <h5 className="font-weight-bold mb-2 text-center" style={{ color: '#333' }}>
                                No tienes agregado precios por sucursal
                            </h5>
                            <p className="text-muted text-center mb-4" style={{ maxWidth: '500px', fontSize: '15px' }}>
                                Si deseas, puedes asignar precios diferentes de los generales para una sucursal en específico o para todas
                            </p>
                            <button
                                type="button"
                                className="btn btn-light btn-sm shadow-sm"
                                onClick={() => setMostrarFormulario(true)}
                            >
                                + Agregar sucursal
                            </button>
                        </div>
                    ) : (
                        <div className="form-group mt-2">
                            <FieldArray
                                name="precios_sucursal"
                                component={preciosSucursal}
                                sucursales={sucursales}
                                sucursal={sucursal}
                                changeSucursal={changeSucursal}
                                sucursal_activo={sucursal_activo}
                                nombres_precios={nombres_precios}
                                changeSucursalActivo={changeSucursalActivo}
                                conf_porcentaje_precio={conf_porcentaje_precio}
                                cambioPorcentajePrecio={cambioPorcentajePrecio}
                                precios_sucursalValue={precios_sucursalValue}
                                nombreFormulario={nombreFormulario}
                                readOnlyMode={readOnlyMode}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PrecioSucursalSection;